import { useLocation } from "react-router-dom";
import { Div } from "./styled";
import { StyledLoading, Wrapper } from "./styled";
import { selectIsLightMode, selectIsNoon } from "../../../../mainApp/features/DataSlice/dataSlice";
import { useSelector } from "react-redux";

const LoadingPage = ({isHighZIndex}) => {
  const theme = useSelector(selectIsLightMode);
  const noonMode = useSelector(selectIsNoon);
  const location = useLocation();
  const shouldUseHighZIndex = isHighZIndex || location.pathname === "/";
  
  return(
   <Div isLight={theme} isNoon={noonMode} isHighZIndex={shouldUseHighZIndex}>
    <Wrapper>
      <StyledLoading isLight={theme}/>
    </Wrapper>
  </Div>
  )

};

export default LoadingPage;
